import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'
import chalk from 'chalk'
import moment from 'moment'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    dayMode: false,
    slides: [],
    filteredSlides: [],
    customImages: {},
    activeSlide: 0,
    preload: true,
    slidesTimeout: 15000,
    dayTime: '07:30',
    nightTime: '19:30',
    preloadTimeout: 1000,
    reloadTime: '04:00:00',
    noInternetScreen: false,
    debug: false,
    debugWeather: false,
    debugFixedSlide: false,
    debugDisableTimeWeather: false,
    displayDebug: true,
    bearExit: false,
    dateTime: '',
    ymdhikDateTime: '',
    cmsUrl: 'https://cms.sinaibabies.ca',
    axiosSettings: {
      'async': true,
      'crossDomain': true,
      'method': 'GET',
      'headers': {
        'Accept': '*/*',
        'Cache-Control': 'no-cache',
        'cache-control': 'no-cache',
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
        'crossdomain': true
      }
    }
  },
  getters: {
    dayMode: state => state.dayMode,
    activeSlide: state => state.filteredSlides[state.activeSlide],
    nextSlide: state => state.filteredSlides[(state.activeSlide + 1) % state.slides.length],
    preload: state => state.preload,
    types: state => {
      return state.filteredSlides.map((elem) => {
        return elem.type
      })
    },
    reloadTimeEnd: state => {
      return `${state.reloadTime.split(':')[0]}:${state.reloadTime.split(':')[1]}:${parseInt(state.reloadTime.split(':')[2]) + state.slidesTimeout / 1000 + 1}`
    }
  },
  mutations: {
    TOGGLE_DAY_MODE (state, value = !state.dayMode) {
      state.dayMode = value
    },
    CHANGE_DAY_MODE (state, value) {
      state.dayMode = value
    },
    UPDATE_SLIDES (state, payload) {
      state.slides = payload.slice(0)
    },
    UPDATE_SLIDE (state, value) {
      state.activeSlide = value
    },
    PRELOAD_IMAGE (state, payload) {
      state.customImages[payload.url] = payload.node
    },
    SHOW_PRELOADER (state, value = true) {
      state.preload = value
    },
    SET_DEBUG (state) {
      state.debug = true
    },
    TOGGLE_DEBUG_FIXED_SLIDE (state) {
      state.debugFixedSlide = !state.debugFixedSlide
    },
    TOGGLE_DEBUG_TIME_WEATHER (state) {
      state.debugDisableTimeWeather = !state.debugDisableTimeWeather
    },
    TOGGLE_DISPLAY_DEBUG (state) {
      state.displayDebug = !state.displayDebug
    },
    BEARS_EXIT (state, value) {
      state.bearExit = value
    },
    NO_INTERNET (state, value = true) {
      state.noInternetScreen = value
    },
    SET_DATE_TIME (state, value) {
      state.dateTime = value
    },
    SET_YMDHIK_DATE_TIME (state, value) {
      state.ymdhikDateTime = value
    },
    SET_DAY_AND_NIGHT_TIME (state, value) {
      state.dayTime = value.dayTime
      state.nightTime = value.nightTime
    }
  },
  actions: {
    getSlides ({ commit, dispatch, state }) {
      if (router.currentRoute.name === 'Debug') commit('SET_DEBUG')

      const dateParam = router.currentRoute.query.date

      dispatch('noInternetCheck')
        .then((response) => {
          if (!response) {
            dispatch('manageTime')
              .finally(() => {
                axios({
                  ...state.axiosSettings,
                  'url': `${state.cmsUrl}/api/slides${dateParam ? '?date=' + dateParam.replace(':', '%3A') : ''}`
                })
                  .then((response) => {
                    commit('UPDATE_SLIDES', response.data.data.data)

                    dispatch('reloadFiltered')
                  })
                  .catch((error) => {
                    console.log(chalk.red(error))
                    commit('NO_INTERNET')
                  })
              })
          }
        })

      setTimeout(() => {
        commit('SHOW_PRELOADER', false)
      }, 1200)
    },
    updateSlide ({ state, commit, getters, dispatch }) {
      dispatch('reloadFiltered')

      const today = new Date(state.dateTime)
      const open = new Date(state.dateTime)
      const close = new Date(state.dateTime)

      open.setHours(parseInt(state.reloadTime.split(':')[0]), parseInt(state.reloadTime.split(':')[1]), parseInt(state.reloadTime.split(':')[2]))
      close.setHours(parseInt(getters.reloadTimeEnd.split(':')[0]), parseInt(getters.reloadTimeEnd.split(':')[1]), parseInt(getters.reloadTimeEnd.split(':')[2]))

      if (today >= open && today <= close) {
        window.location.reload()
      }

      dispatch('noInternetCheck').then((response) => {
        if (!response) {
          dispatch('checkIfRefresh')
            .finally(() => {
              dispatch('manageTime')
                .finally(() => {
                  const cappedPayload = !state.debugFixedSlide ? (state.activeSlide + 1) % (state.filteredSlides.length) : state.activeSlide

                  if (getters.activeSlide.type !== state.filteredSlides[cappedPayload].type && ['titledonors', 'donorstitle'].indexOf(`${getters.activeSlide.type}${state.filteredSlides[cappedPayload].type}`) === -1) {
                    commit('SHOW_PRELOADER')
                  }

                  if (`${getters.activeSlide.type}${state.filteredSlides[cappedPayload].type}` === 'donorstitle') {
                    commit('BEARS_EXIT', true)
                  }

                  if (!state.debug || !state.debugFixedSlide) {
                    setTimeout(() => {
                      commit('UPDATE_SLIDE', cappedPayload)
                    }, 1200)
                  }
                })
            })
        }
      })

      setTimeout(() => {
        commit('SHOW_PRELOADER', false)
      }, 1200)
    },
    noInternetCheck ({ state, commit }) {
      navigator.onLine ? commit('NO_INTERNET', false) : commit('NO_INTERNET')

      return state.noInternetScreen
    },
    checkIfRefresh ({ state }) {
      axios({
        ...state.axiosSettings,
        'url': `${state.cmsUrl}/api/refresh${router.currentRoute.query.device ? '?device=' + router.currentRoute.query.device : ''}`
      })
        .then(response => {
          if (response.data.refresh === '1') {
            window.location.reload()
          }
        })
        .catch(error => {
          console.log(chalk.red(error))
        })
    },
    reloadFiltered ({ state, commit }) {
      state.filteredSlides = state.slides.slice(0)
        .filter(elem => {
          if (elem.type === 'custom') {
            const today = new Date(state.dateTime)
            const start = new Date(elem.slide.start_date ? elem.slide.start_date : state.dateTime)
            const end = new Date(elem.slide.end_date ? elem.slide.end_date : state.dateTime)
            start.setHours(parseInt(elem.slide.start_time.split(':')[0]), parseInt(elem.slide.start_time.split(':')[1]), 0)
            end.setHours(parseInt(elem.slide.end_time.split(':')[0]), parseInt(elem.slide.end_time.split(':')[1]), 0)
            console.log()
            return moment(today).diff(moment(start)) >= 0 && moment(today).diff(moment(end)) < 0
          }

          return true
        })

      state.filteredSlides
        .filter(elem => {
          return elem.type === 'custom'
        })
        .forEach((image) => {
          let customImage = new Image()
          customImage.src = `${state.cmsUrl}/storage/${image.slide.image_url}`
          customImage.style.height = '100vh'

          commit('PRELOAD_IMAGE', {
            url: image.slide.image_url,
            node: customImage
          })
        })
    },
    manageTime ({ state, commit }) {
      const dateParam = router.currentRoute.query.date

      axios({
        ...state.axiosSettings,
        'url': `${state.cmsUrl}/api/time${dateParam ? '?date=' + dateParam.replace(':', '%3A') : ''}`
      })
        .then((response) => {
          const usedDate = response.data.isSimulated ? response.data.simulatedDateTime : response.data.currentDateTime
          commit('SET_DATE_TIME', usedDate)

          const exploded = usedDate.split(' ')
          const date = exploded[0]
          const explodedTime = exploded[1].split(':')
          const hours = explodedTime[0] >= 12 ? explodedTime[0] - 12 : explodedTime[0]
          const minutes = explodedTime[1]
          const meridiem = explodedTime[0] >= 12 ? 'PM' : 'AM'
          commit('SET_YMDHIK_DATE_TIME', `${date} ${hours}:${minutes} ${meridiem}`)

          commit('SET_DAY_AND_NIGHT_TIME', {
            dayTime: response.data.dayTime ? response.data.dayTime : state.dayTime,
            nightTime: response.data.nightTime ? response.data.nightTime : state.nightTime
          })

          if (!state.debugDisableTimeWeather && !state.debugWeather) {
            commit('CHANGE_DAY_MODE', response.data.dayOrNight === 'day')
          }
        })
        .catch((error) => {
          const today = new Date()

          commit('SET_DATE_TIME', `${today.getFullYear()}-${(today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)}-${today.getDate() < 10 ? '0' + today.getDate() : today.getDate()} ${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`)
          commit('SET_YMDHIK_DATE_TIME', `${today.getFullYear()}-${(today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)}-${today.getDate() < 10 ? '0' + today.getDate() : today.getDate()} ${today.getHours() > 12 ? today.getHours() - 12 : today.getHours()}:${today.getMinutes()} ${today.getHours() >= 12 ? 'PM' : 'AM'}`)

          const day = new Date()
          const night = new Date()
          day.setHours(parseInt(state.dayTime.split(':')[0]), parseInt(state.dayTime.split(':')[1]), 0)
          night.setHours(parseInt(state.nightTime.split(':')[0]), parseInt(state.nightTime.split(':')[1]), 0)
          if (!state.debugDisableTimeWeather && !state.debugWeather) {
            if (state.dayMode === false && today >= day && today < night) {
              commit('TOGGLE_DAY_MODE', true)
            } else if (state.dayMode === true && today >= night) {
              commit('TOGGLE_DAY_MODE', false)
            }
          }
          console.log(chalk.red(error))
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js